import Vue from "vue";

let instance;

export const getNotificationService = () => instance;

export const useNotifications = ({ ...options }) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        timeoutHandle: null,
        notifications: [],
      };
    },
    methods: {
      info(message, heading = null, action = null) {
        this.add({ message, heading, action, css: "fpds-Notification--info", icon: "info" });
      },

      success(message, heading = null, action = null) {
        this.add({
          message,
          heading,
          action,
          css: "fpds-Notification--success",
          icon: "success",
        });
      },

      warning(message, heading = null, action = null) {
        this.add({
          message,
          heading,
          action,
          css: "fpds-Notification--warning",
          icon: "warning",
        });
      },

      error(message, heading = null, action = null) {
        this.add({
          message,
          heading,
          action,
          css: "fpds-Notification--danger",
          icon: "error",
        });
      },

      add(notification) {
        this.notifications.push(notification);
        this.startTimeOut();
      },

      startTimeOut() {
        if (this.timeOutHandle) {
          return;
        }

        if (this.notifications.length) {
          this.timeOutHandle = setTimeout(() => {
            this.remove(this.notifications[0]);
          }, options?.notificationInterval || 5000);
        }
      },

      remove(notification) {
        clearTimeout(this.timeOutHandle);
        this.timeOutHandle = null;

        const index = this.notifications.indexOf(notification);
        if (index !== -1) {
          this.notifications.splice(index, 1);
        }
        this.startTimeOut();
      },
    },
  });

  return instance;
};

export const NotifcationsPlugin = {
  install(Vue, options) {
    Vue.prototype.$notifications = useNotifications(options);
  },
};
